export default "__VITE_ASSET__C$$QVAyk__"